<template>
  <v-container class="p-0">
    <div class="py-4">
      <v-btn text ref="button-toolbar-close" @click="$emit('close')">
        <v-icon>close</v-icon>
        <span>{{ $t('general.close') }}</span>
      </v-btn>
    </div>
    <v-card
      v-if="loading"
      height="150px"
      class="rounded-lg d-flex justify-center align-center"
      flat
    >
      <div>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-card>
    <!-- CREATE ORGANIZATION PLAN -->
    <div v-else>
      <v-row
        v-if="
          Object.keys(organizationPlan).length === 0 || !organizationPlan.id
        "
        class="fill-height"
      >
        <v-col cols="12" class="d-flex justify-center align-center fill-height">
          <CreateOrganizationPlan
            :width="600"
            :title="$t('organization_billing.create.title')"
            :description="$t('organization_billing.create.subtitle')"
            :accept-text="$t('actions.accept')"
            :cancel-text="$t('actions.cancel')"
            @proceed="submitInit($event)"
            @close="$emit('close')"
          />
        </v-col>
      </v-row>
      <v-row v-else class="px-4">
        <v-col cols="12">
          <UpdateOrganizationPlan :organization_id="organization_id" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CreateOrganizationPlan from '@/components/Organization/Details/OrganizationPlan/CreateOrganizationPlan.vue'
import UpdateOrganizationPlan from '@/components/Organization/Details/OrganizationPlan/UpdateOrganizationPlan.vue'
import plansMixin from '@/mixins/plans'

export default {
  name: 'OrganizationPlan',
  components: { CreateOrganizationPlan, UpdateOrganizationPlan },
  mixins: [plansMixin],
  props: {
    organization_id: { type: Number, required: true }
  },
  data() {
    return {
      loading: false,
      successModal: false,
      valid: true,
      currencySelectedMonthly: null,
      plansCustom: [],
      organizationPlanUpdate: {
        id: null,
        pricing_model_id: null,
        amount: null,
        plan_id: null,
        currency_id: null,
        fee_percentage: null,
        organization_id: null,
        plan_automation_id: null,
        currency: null
      },
      rules: {
        currencyRules: [v => !!v || 'This field is required'],
        planRules: [v => !!v || 'This field is required'],
        automationPlanRules: [v => !!v || 'This field is required'],
        percentageRules: [
          v => !!v || 'This field is required',
          v => /^\d+(\.\d+)?$/.test(v) || 'Number only',
          v =>
            (v && v.toString().split('.').length < 2) ||
            (v && v.toString().split('.')[1].length <= 2) ||
            'No more than 2 digits after the decimal point',
          v => (v && v >= 0) || 'Min should be above 0%',
          v => (v && v <= 100) || 'Max should not be above 100%'
        ],
        amountRules: [
          v => !!v || 'This field is required',
          v => /^\d+(\.\d+)?$/.test(v) || 'Number only',
          v =>
            (v && v.toString().split('.').length < 2) ||
            (v && v.toString().split('.')[1].length <= 2) ||
            'No more than 2 digits after the decimal point',
          v => (v && v >= 0) || 'Min should be above 0'
        ],
        pricingModelRules: [v => !!v || 'This field is required']
      }
    }
  },
  async created() {
    try {
      this.loading = true
      await this.getPlans()
      await this.getPricingModels()
    } catch (error) {
      console.log(error)
      this.$noty.error('Error getting data')
    } finally {
      this.loading = false
    }
  },
  computed: {
    ...mapState({
      organizationPlan: ({ organization: { organizationPlan } }) =>
        organizationPlan,
      organizationCurrencyCode: ({ organization: { organization } }) =>
        organization.currency,
      currencies: ({ countries: { currencies } }) => currencies,
      plans: ({ plans: { plans } }) => plans,
      services: ({ plans: { services } }) => services,
      pricingModels: ({ pricingModels: { pricingModels } }) => pricingModels
    })
  },
  methods: {
    ...mapActions({
      getPlans: 'plans/getPlans',
      createOrganizationPlan: 'organization/createOrganizationPlan',
      getPricingModels: 'pricingModels/getPricingModels'
    }),
    async submitInit(organizationPlanCreate) {
      const {
        plan_id,
        amount,
        services,
        currency_id,
        fee_percentage
      } = organizationPlanCreate
      const { organization_id } = this

      await this.createOrganizationPlan({
        amount,
        plan_id,
        services,
        currency_id,
        organization_id,
        fee_percentage: fee_percentage ? fee_percentage : null
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
